var _path, _path2, _path3, _path4, _radialGradient, _path5, _path6, _radialGradient2, _path7, _path8, _radialGradient3, _path9, _path10, _radialGradient4, _path11, _path12, _path13, _path14, _path15, _radialGradient5, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6aa5ad",
    d: "m60.7 100.2l-.28-39.55l5.14.28l.29 41.41z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f7377",
    d: "M48.94 107.67c-3.02-.15-4.56 2.13-4.17 6.4s2.9 10.74 11.64 10.57c10.09-.19 10.85-7.21 10.69-14.97c-.11-5.4 0-9.68-.29-9.87s-7.29-.38-7.68.01s-.1 8.83-.19 10.86s.26 6.12-3.49 6.01c-2.91-.08-3.3-2.52-3.3-3.69s.67-5.13-3.21-5.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#937ef3",
    d: "m53.24 44.47l9.62-17.32S43.88 24.8 27.03 37.89C5.6 54.53 9 72.78 9 72.78S17.16 65 23.84 65.6s15.05 8.67 15.05 8.67z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5547f4",
    d: "m65.19 32.46l-1.38-5.31s19.28-.21 33.63 9.2C122.13 52.53 119.4 70.6 119.4 70.6s-5.36-7.46-17.12-6.93S86.2 74.7 86.2 74.7z"
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "notoUmbrellaWithRainDrops0",
    cx: 83.836,
    cy: 1.342,
    r: 27.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#71d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#6cd2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#5dcefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#44c8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#22c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#00b7e2"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notoUmbrellaWithRainDrops0)",
    d: "M84.12 1.12c-1.2.07-2.37 3.37-4.14 7.23s-5.02 7.67-3.42 13.3c2.18 7.66 14.9 7.61 15.23-2.71c.11-3.54-3.03-8.55-4.03-10.98s-2.21-6.92-3.64-6.84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ace8fe",
    d: "M80.6 14.11c-1.44.11-2.71 2.38-2.21 5.72s2.84 4.2 3.92 3.7c1.31-.61.38-2.61.04-4.78s.39-4.81-1.75-4.64"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "notoUmbrellaWithRainDrops1",
    cx: 101.605,
    cy: 26.594,
    r: 23.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#71d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6cd2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#5dcefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798,
    stopColor: "#44c8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#22c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#00b7e2"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notoUmbrellaWithRainDrops1)",
    d: "M101.73 25.96c-1.14-.07-1.18 2.63-4.51 8.1c-2.21 3.62-4.19 7.73-3.02 11.81c2.27 7.9 15.04 7.55 15.37-2.76c.11-3.54-2.01-6.41-3.76-9.73c-1.23-2.31-3.16-7.36-4.08-7.42"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ace8fe",
    d: "M98.65 38.46c-1.27-.43-3.07 1.78-2.91 5.09c.16 3.29 2.54 5.12 3.89 4.11c1.26-.95-.28-3.66-.28-5.34c-.01-1.68.59-3.42-.7-3.86"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "notoUmbrellaWithRainDrops2",
    cx: 22.597,
    cy: 28.469,
    r: 23.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#71d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.718,
    stopColor: "#6cd2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#5dcefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#44c8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#22c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964,
    stopColor: "#00b7e2"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notoUmbrellaWithRainDrops2)",
    d: "M22.75 28.56c-1.01-.04-2.18 3.17-3.95 7.03s-5.02 6.19-3.87 12.37c1.51 8.1 15.38 8.51 15.71-1.8c.11-3.54-2.8-8.29-3.98-10.63c-1.44-2.88-3.02-6.93-3.91-6.97"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ace8fe",
    d: "M18.43 41.6c-2.03-.03-2.33 4.16-1.76 5.97c.56 1.78 1.4 3.31 3.12 2.92c1.69-.39.56-3.2.27-4.8c-.29-1.61-.01-4.06-1.63-4.09"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "notoUmbrellaWithRainDrops3",
    cx: 41.169,
    cy: 1.16,
    r: 25.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#71d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709,
    stopColor: "#6cd2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#5dcefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#44c8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.883,
    stopColor: "#22c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.934,
    stopColor: "#00b7e2"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notoUmbrellaWithRainDrops3)",
    d: "M41.86 1.85c-1.14-.1-1.97 2.7-2.39 3.65c-1 2.22-5.9 8.33-5.78 14.02c.13 6.35 5.17 8.03 8.38 7.91c3.43-.12 8.32-2.23 7.34-8.92c-.38-2.57-1.85-5.51-3.16-8.44c-1.95-4.39-2.7-8.07-4.39-8.22"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ace8fe",
    d: "M38.54 14.73c-1.51-.43-2.83 2.35-2.51 5.36c.3 2.88 1.77 4.62 3.01 4.25c2.62-.78.64-3.35.57-5.46c-.06-1.87.27-3.77-1.07-4.15"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e62ed",
    d: "M86.25 73.94s-1.07-17.66-5.17-26.74C73.6 30.63 63.3 27.42 63.3 27.42s-12.4 6.09-18.91 21.12s-5.4 25.64-5.4 25.64s10.03-11.46 24.63-9.88c14.6 1.57 22.63 9.64 22.63 9.64"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ca4ab",
    d: "M59.7 27.86c-.13-.51-.02-7.3-.06-8.76c-.06-2.16 1.77-3.54 3.43-3.49c2.16.06 2.92 1.97 2.98 3.3s.07 8.79.06 8.88c-.08.78-1.22 1.52-3.24 1.52c-1.46.02-3-.75-3.17-1.45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#004dae",
    d: "M86.18 76.22c1.52-.09 7.56-10.49 17.06-10.4c12.89.13 14.54 6.82 15.89 6.14c1.49-.76-.7-3.54-2.65-5.55c-2.75-2.84-7.16-4.56-14-4.12c-9.96.65-16.39 9.49-16.39 9.49s-8.5-9.27-23.39-9.27C48.29 62.51 39 72.75 39 72.75s-4.71-8.33-16.17-8.53c-10.13-.18-14.51 7.98-13.8 8.69s6.11-5.76 13.67-5.43c10.4.44 14.04 9.13 16.03 9.18s9.75-10.43 24.15-10.18c15.46.27 21.88 9.83 23.3 9.74"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "notoUmbrellaWithRainDrops4",
    cx: 62.792,
    cy: 34.798,
    r: 23.038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#71d3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581,
    stopColor: "#6cd2fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#5dcefa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#44c8f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833,
    stopColor: "#22c0eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.907,
    stopColor: "#00b7e2"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#notoUmbrellaWithRainDrops4)",
    d: "M63.16 33.82c-.94.02-2.37 3.37-4.14 7.23s-5.43 8.06-3.31 13.51c2.48 6.35 14.46 6.63 15.01-3.27c.2-3.54-2.87-8.23-3.92-10.63c-1.76-4.01-2.79-6.86-3.64-6.84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ace8fe",
    d: "M58.48 48.04c-1.35-.1-2.29 2.44-1.55 5c.75 2.6 2.31 3.66 3.6 3.15c1.65-.65.3-2.55-.05-4.25s.05-3.75-2-3.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.7096fc1c7225e48065f2518ff5777923.svg";
export { ForwardRef as ReactComponent };